// src/layout/SubscriptionModal.jsx

import { Modal } from "antd";
import { X } from "lucide-react";

const SubscriptionModal = ({ open, onClose, navigate }) => {
  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onClose}
      centered
      closeIcon={<X className="text-white" />}
      styles={{
        content: {
          backgroundColor: "#1f2937", // gray-800
          border: "1px solid #374151", // gray-700
        },
        mask: {
          backdropFilter: "blur(5px)",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
    >
      <div className="text-center">
        <h2 className="text-lg font-semibold mb-2 text-white">
          You're out of uploads!
        </h2>

        <p className="text-gray-400 mb-4">
          Upgrade your plan to continue using XynexAI
        </p>

        <button
          onClick={() => {
            onClose();
            navigate("/dashboard/subscription");
          }}
          className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white border-0 shadow-[0_0_15px_rgba(168,85,247,0.4)] hover:shadow-[0_0_25px_rgba(168,85,247,0.6)] w-full sm:w-auto h-10 px-6 font-bold transform hover:-translate-y-0.5 transition-all duration-300 rounded-full"
        >
         🚀 Upgrade Plan
        </button>
      </div>
    </Modal>
  );
};

export default SubscriptionModal;
